import { AlertCircle } from 'lucide-react';

export function PageError({ title, message }: { title: string; message: string | null | undefined }) {
    return (
        <div className="bg-state-error/10 border border-state-error/30 rounded-lg p-4 flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-state-error shrink-0 mt-0.5" />
            <div className="flex-1">
                <h4 className="font-semibold text-graphite mb-1">{title}</h4>
                {message && <p className="text-sm text-state-error">{message}</p>}
            </div>
        </div>
    );
}
